import { useMemo } from 'react';

/**
 * useStepConfig
 *
 * @param {number} step - current step index
 * @param {function} generateConfig - a callback function that returns config object
 * @param {array} deps - array of dependencies to generate config
 * @returns {object} the config for the current step
 */
export default function useStepConfig(step, generateConfig, deps = []) {
    const stepsConfig = useMemo(generateConfig, deps);

    return useMemo(() => stepsConfig[step] || {}, [step, stepsConfig]);
}